import { any, bool, func, node, oneOfType, string } from 'prop-types';
import React from 'react';
import { Button, Col, Form, Row } from 'reactstrap';

import withConfirm from '../with-confirm';

const DiscardButtonWithConfirmation = withConfirm(
  'Do you really want to discard your changes?',
)(Button);

function DiscardableForm({
  children,
  onSubmit,
  onDiscard,
  className,
  saveLabel,
  disabled,
}) {
  return (
    <Form onSubmit={onSubmit} className={className}>
      {children}
      {(onSubmit || onDiscard) && (
        <Row>
          <Col>
            <div className="btn-group">
              {onSubmit && (
                <Button type="submit" color="primary" disabled={disabled}>
                  {saveLabel}
                </Button>
              )}
              {onDiscard && (
                <DiscardButtonWithConfirmation
                  onClick={onDiscard}
                  color="secondary"
                >
                  Discard Changes
                </DiscardButtonWithConfirmation>
              )}
            </div>
          </Col>
        </Row>
      )}
    </Form>
  );
}

DiscardableForm.propTypes = {
  children: any, // eslint-disable-line react/forbid-prop-types
  onSubmit: func,
  onDiscard: func,
  className: string,
  saveLabel: oneOfType([string, node]),
  disabled: bool,
};

DiscardableForm.defaultProps = {
  children: '',
  onSubmit: undefined,
  onDiscard: undefined,
  className: '',
  saveLabel: 'Save',
  disabled: false,
};

export default DiscardableForm;
